export default "__VITE_ASSET__Cg36gxH0__"